"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsButtonV2 = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DmsDoubleBlind = require("../../DmsDoubleBlind/DmsDoubleBlind");
var _index = require("../../../index");
const _excluded = ["children", "isDoubleBlind", "doubleBlindHeaderText", "onClick"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Renders an icon inside an IconButton using Material-UI IconButton.
 * 
 * @component
 * @param {string} icon Name of the Material-UI icon component to render
 */
const DmsButtonIcon = _ref => {
  let {
    icon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "button-icon"
  }, icon);
};

/**
 * Renders the root button element using Material-UI Button.
 * 
 * @component
 * @param {Object} props Props for Material-UI Button component
 */
const DmsButtonRoot = _ref2 => {
  let {
      children,
      isDoubleBlind,
      doubleBlindHeaderText,
      onClick
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const [trigger, setTrigger] = (0, _react.useState)(false);
  const handleClick = e => {
    if (isDoubleBlind) {
      setTrigger(true);
      return;
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Button, _extends({}, props, {
    onClick: handleClick
  }), children), isDoubleBlind && /*#__PURE__*/_react.default.createElement(_DmsDoubleBlind.DmsDoubleBlind, {
    show: trigger,
    setShowDoubleBlind: setTrigger,
    onSuccess: onClick,
    onClose: () => setTrigger(false),
    headerText: doubleBlindHeaderText || _index.intl.get('DoubleBlindHeader').d('Double Blind Authentication')
  }));
};

/**
 * Renders text inside a Typography component with padding.
 * 
 * @component
 * @param {string} text Text to display inside the Typography
 */
const DmsButtonText = _ref3 => {
  let {
    text
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    style: {
      padding: '10px'
    }
  }, text);
};

/**
 * Composite component that exposes the individual components:
 * - `Root`: Renders the root button element.
 * - `Icon`: Renders an icon inside an IconButton.
 * - `Text`: Renders text inside a Typography.
 */
const DmsButtonV2 = exports.DmsButtonV2 = {
  Root: DmsButtonRoot,
  Icon: DmsButtonIcon,
  Text: DmsButtonText
};